// extracted by mini-css-extract-plugin
module.exports = {"dateContainer":"DateSection_dateContainer__gLyZr","emptyContainer":"DateSection_emptyContainer__r9VT_","itemCardContainer":"DateSection_itemCardContainer__c2RRf"};